if (!customElements.get('sm-product-extras')) {
  customElements.define('sm-product-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('submit', event => this.addExtra(event));
    }

    async addExtra(event) {
      const form = event.target.closest('[data-sm-extras-form]');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      const button = form.querySelector('[data-sm-extras-add]');
      if (!button || button.disabled) return;
      const item = form.closest('[data-sm-extras-item]');
      const error = item.querySelector('[data-sm-extras-error]');
      const originalLabel = button.innerHTML;
      const originalAriaLabel = button.getAttribute('aria-label');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.adding;
      error.hidden = true;
      error.textContent = '';
      let added = false;
      try {
        const variantId = new FormData(form).get('id');
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        let payload;
        try { payload = await response.json(); } catch { payload = null; }
        if (!response.ok) {
          throw new Error(payload?.description || payload?.message || this.dataset.errorMessage);
        }
        added = true;
        button.textContent = this.dataset.added;
        button.setAttribute('aria-label', this.dataset.added);
        button.classList.add('sm-extras__button--added');
        this.querySelector('[data-sm-extras-feedback]').hidden = false;
        this.querySelector('[data-sm-extras-status]').textContent = this.dataset.addedMessage;
        try {
          if (typeof window.XtraTheme?.ensureCustomAsyncRuntime === 'function') {
            const cart = await window.XtraTheme.ensureCustomAsyncRuntime();
            if (cart && typeof cart.refresh === 'function') {
              const refreshed = await cart.refresh();
              if (refreshed) {
                document.querySelectorAll('#cart-count, #cart-count--m').forEach(count => {
                  const link = count.closest('a');
                  const label = link?.querySelector('.hidden')?.textContent?.trim();
                  const quantity = count.textContent.trim();
                  if (link && label && quantity) {
                    link.setAttribute('aria-label', `${label} (${quantity})`);
                  }
                });
                if (typeof cart.open === 'function') {
                  await cart.open({ redirect: false, fallbackUrl: this.dataset.cartUrl });
                }
              }
            }
          }
        } catch {}
      } catch (failure) {
        error.textContent = failure.message || this.dataset.errorMessage;
        error.hidden = false;
      } finally {
        button.removeAttribute('aria-busy');
        if (!added) {
          button.disabled = false;
          button.innerHTML = originalLabel;
          button.setAttribute('aria-label', originalAriaLabel);
        }
      }
    }
  });
}
